// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"243":"85e62a48","273":"9f1f2e1d","333":"9f1f2e1d","533":"701b9aea","548":"920a1922","837":"9f1f2e1d"}[chunkId] + ".chunk.css";
};